import React from "react";

function HomeIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3619_46705)">
        <path
          d="M22.0101 14.049C22.7043 13.6961 22.7728 12.768 22.2265 12.213C19.9367 9.88668 15.7697 5.58614 13.989 5.57149C11.6134 5.55186 8.24488 10.1354 6.14052 12.9449C5.60708 13.6571 5.9109 14.7906 6.75658 15.0674C7.11325 15.1842 7.46862 15.2716 7.81398 15.2898C7.83347 15.2908 7.85278 15.2935 7.87172 15.2983C8.01692 15.3345 8.11005 15.4756 8.08551 15.6233C7.70794 17.8945 7.13204 21.3071 8.61966 22.044C8.7471 22.1072 8.87556 22.1717 9.00276 22.2353C9.1068 22.2873 9.21852 22.3243 9.33834 22.3445C10.5101 22.5431 11.6402 22.6541 12.7574 22.6955C13.2841 22.715 13.7234 22.3036 13.8121 21.7841C13.8978 21.2832 14.0246 20.7143 14.1858 20.1769C14.346 19.6394 14.5408 19.135 14.7602 18.7632C14.9798 18.3909 15.2239 18.152 15.4856 18.1469L15.4987 18.1462H15.5113H15.5253L15.5383 18.1452C15.8006 18.1406 16.0541 18.3685 16.2888 18.7305C16.5234 19.0935 16.738 19.5896 16.92 20.1195C17.1028 20.6496 17.2538 21.2135 17.3597 21.7103C17.4536 22.1488 17.8555 22.4674 18.3007 22.4137C18.5927 22.3785 18.8869 22.3407 19.184 22.3005C21.1588 22.0334 20.5814 18.3715 20.1717 15.9044C20.0692 15.2869 20.4524 14.7064 21.0365 14.4815C21.3678 14.3539 21.6927 14.2104 22.0101 14.049Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3619_46705">
          <rect
            width="18.2857"
            height="18.2857"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HomeIcon;
